"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAuthConnector = void 0;
const react_1 = require("react");
const constants_1 = require("../utils/constants");
/**
 * For removing connected app session
 * Not used right now
 */
function useAuthConnector() {
    (0, react_1.useEffect)(() => {
        const listen = (event) => {
            let eventData;
            try {
                eventData = JSON.parse(event.data);
            }
            catch (err) {
                eventData = event.data;
            }
            if (eventData.type == constants_1.eventTypes.disconnect) {
                // remove from tria.connected.apps local storage
            }
        };
        window.addEventListener('message', listen);
        return () => {
            window.removeEventListener('message', listen);
        };
    }, []);
}
exports.useAuthConnector = useAuthConnector;
